export const USER_GET_REQUESTED = 'USER_GET_REQUESTED';
export const USER_GET_SUCCEED = 'USER_GET_SUCCEED';
export const USER_GET_FAILED = 'USER_GET_FAILED';
